import { flowRight as compose } from 'lodash';

import dataView from '~lib/common/hoc/dataView';
import renameProps from '~lib/common/hoc/renameProps';
import withUser from '~lib/common/hoc/withUser';

import MonitorSelector from './MonitorSelector.vue';
import queries from '../../../graphql/queries/MonitorModel';

const enhance = compose(
  dataView({ queries }),
  renameProps({ data: 'monitorModels' }),
  withUser()
);

export default enhance(MonitorSelector);
